export default function eraseLocalStorageInfo() {
  localStorage.removeItem("portal-front-token");
  localStorage.removeItem("portal-front-refresh-token");
  localStorage.removeItem("user-settings");
  localStorage.removeItem("my-load-table");
}
